var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"text-align":"center"}},[_c('el-button',{attrs:{"type":"primary","loading":_vm.isLoading},on:{"click":_vm.onAssess}},[_vm._v("生成评估")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }